<template>
    <div  style="min-height: 80vh" class="mb-15">
        <div class="mb-6">
            <div v-if="$route.params.id === 'profiles'" class="title py-3 px-4 title-div" style="font-family: 'Mv Eamaan XP' !important;">
                <p class="caption mb-0">
                    <a href="#/" class="grey--text text--lighten-2">ފުރަތަމަ ސަފްޙާ / </a>
                    <a class="grey--text text--lighten-2">{{getTitle($route.params.category, 'category')}} / </a>
                    <a :href="`#/${$route.params.category}/${$route.params.contentType}`" class="grey--text text--lighten-2">{{getTitle($route.params.contentType)}}</a>
                </p>
                ޑިވިޜަންތަކުގެ އިސްވެރިން
            </div>
            <div v-else class="title py-3 px-4 title-div"  style="font-family: 'Mv Eamaan XP' !important;">
                <p class="caption mb-0">
                    <a href="#/" class="grey--text text--lighten-2">ފުރަތަމަ ސަފްޙާ / </a>
                    <a class="grey--text text--lighten-2">{{getTitle($route.params.category, 'category')}} / </a>
                    <a :href="`#/${$route.params.category}/${$route.params.contentType}`" class="grey--text text--lighten-2">{{getTitle($route.params.contentType)}}</a>
                </p>
                {{newsTitle}}
            </div>
            <v-progress-linear
            v-if="loadingPage"
            indeterminate
            color="primary"
            ></v-progress-linear>
        </div>
        <v-row row wrap class="mt-3 px-4">
            <v-col md="3" class="pr-0 hidden-sm-and-down">
                <div class="elevation-1">
                <div
                v-for="(value, key) in navItems"
                :key="key"
                >
                    <v-list-group
                    dense
                    :value="$route.params.category === value.eng ? true : false"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title class="px-0 eamaan">{{value.dhi}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                        v-for="(n, indexSub) in value.subItems"
                        :key="n.eng"
                        dense
                        @click="() => {}"
                        link
                        :href="n.eng === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n.eng === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${value.eng}/${indexSub === 0 && value.eng === 'Attorney General' ? n.dhi : n.eng}`"
                        >
                            <v-list-item-title class="px-1 font-weight-light" :class="$route.params.contentType === n.eng ? 'info--text' : ''">{{n.dhi}}</v-list-item-title>
                            <v-divider></v-divider>
                        </v-list-item>
                    </v-list-group>
                    <v-divider></v-divider>
                </div>
                </div>
            </v-col>
            <v-col cols="11" sm="11" md="8" >
                <div v-if="!loadingPage">
                    <div v-if="$route.params.id === 'profiles'">
                        <p class="display-1 mb-5 primary--text" style="font-family: 'Mv Eamaan XP' !important;">
                            ޑިވިޜަންތަކުގެ އިސްވެރިން 
                        </p>
                        <div v-for="(n, index) in divisionHeads" :key="index + 'profile'">
                            <v-row>
                                <v-col cols="4" md="2">
                                    <v-img
                                    max-height="200" 
                                    contain
                                    :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                                    :lazy-src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                                    class="transparent lighten-2"
                                    >
                                        <template v-slot:placeholder>
                                            <v-layout
                                                fill-height
                                                align-center
                                                justify-center
                                                ma-0
                                                >
                                                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                            </v-layout>
                                        </template>
                                    </v-img>
                                </v-col>
                            </v-row>
                            <p class="mt-3"><a :href="`#/About%20Us/Organization%20Structure/profile/${n.Title.split('#')[0]}`" class="title"  style="font-family: 'Mv Eamaan XP' !important;">{{n.Title.split('#').length > 0 ? n.Title.split('#')[1] : ''}}</a><br>
                            <span class="subheading text-xs-center">{{n.Title.split('#')[0]}}</span><br> </p>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="contents[0]">
                        <p class="headline mb-5 primary--text" style="font-family: 'Faruma' !important;" v-html="contents[0].Title"></p>
                        <p class="caption">{{contents[0].Date | moment("DD-MM-YYYY")}}</p>
                        <v-carousel
                        v-if="getImage(contents[0]).length > 1"
                        cycle
                        show-arrows-on-hover
                        hide-delimiters
                        height="400px"
                        class="mb-5"
                        >
                            <v-carousel-item
                            v-for="(slide, i) in getImage(contents[0])"
                            :key="i.ID"
                            >
                                <v-img
                                :src="getImageUrl(slide.ID)"
                                class="transparent mb-4"
                                style="height: 400px"
                                aspect-ratio="1"
                                position="bottom center"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                        >
                                        <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <v-img
                        v-if="getImage(contents[0])[0]"
                        :src="getImageUrl(getImage(contents[0])[0].ID)"
                        class="transparent mb-4"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                                >
                                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>

                        <div class="px-0" v-html="contents[0] ? contents[0].Body : ''"></div>
                        <div v-if="contents[0].Files.length > 0">
                            <p v-for="a in getWithoutImages(contents[0].Files)" :key="a.ID + 'FileDownload'">
                                <v-icon color="info">mdi-file</v-icon> <a :href="`${$url}/downloadfile/${a.ID}`" v-html="a.FileTitle"></a>
                            </p>
                        </div>
                        </div>
                        <div v-else>
                            <p class="title"  style="font-family: 'Mv Eamaan XP' !important;">ހޯއްދަވަން އުޅުއްވި ސަފުހާ ނުފެނުނު!</p>
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col cols="1">
                <div class="sticky text-left">
                    <v-btn icon class="my-2" @click="printPage()" color="grey lighten-1">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`http://www.facebook.com/sharer.php?u=${currentUrl}`" target="_blank" icon class="my-2" color="grey lighten-1">
                        <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`https://twitter.com/intent/tweet?url=${currentUrl}`" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-twitter</v-icon>
                    </v-btn>
                    <br>
                    <v-btn href="mailTo:info@agoffice.gov.mv" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                </div>
            </v-col>

        </v-row>
        
    </div>
</template>
<script>
    export default {
        props: ['navItems'],
        data: ()=>({
            divisionHeads: [],
            contents: [],
            currentUrl: window.location.href,
            loadingPage: true,
            newsTitle: ''
        }),
        created () {
            // console.log(this.$route.params.id)
            if (this.$route.params.id === 'profiles') {
                this.$http.get(`${this.$url}/pagination/1/Division%20Heads?limit=20&page=0&sort=id%20desc`).then((response) => {
                    this.divisionHeads = response.data.data.rows
                    this.loadingPage = false
                    // console.log(this.divisionHeads)
                })
            }
            else {
                this.$http.get(`${this.$url}/pagination/1/${this.$route.params.category}?limit=1&page=0&id.contains=${this.$route.params.id}&sort=id%20desc`).then((response)=>{
                    this.contents = response.data.data.rows
                    this.newsTitle = this.contents.length > 0 ? this.contents[0].Title : ''
                    this.loadingPage = false
                // if (this.news.length > 0) {
                //   this.items.push({text: this.news[0].Category == 'Pressrelease' ? 'ނޫސްބަޔާން' : this.news[0].Category == 'News' ? 'ޙަބަރު' : 'އިއުލާން', disabled: false, href: ''}, {text: this.news[0].Title.substring(0, 50) + '....', disabled: true, href: ''})
                // }
                }).catch(err => {
                    this.loadingPage = false
                })
            }
        },
        methods: {
            getWithoutImages (files) {
                return files.filter(item => !item.FileType.includes('image'))
            },
            getImage(item) {
                // console.log(item.Files && item.Files.length > 0)
                if (item.Files && item.Files.length > 0) {
                    let images = item.Files.filter(obj => obj.FileType.includes('image'))
                    // console.log(images)
                    if (images.length > 0) {
                        // return `${this.$url}/downloadfile/${images[0].ID}`
                        return images
                    }
                    else {
                    return []
                    }
                }
                else {
                    return []
                }
            },
            getImageUrl (id) {
                return `${this.$url}/downloadfile/${id}`
            },
            getTitle (title, type) {
            let foo = ''
            if (type === 'category') {
                for(let item of this.navItems) {
                    if (item.eng === title) {
                        foo = item.dhi
                        break
                    }
                }
            } else {
                for(let item of this.navItems) {
                    for (let sub of item.subItems) {
                        if (sub.eng.includes(title)) {
                            foo = sub.dhi
                            break
                        }
                    }
                }
            }
            return foo
        }
        }
    }
</script>
<style>
p.ql-align-justify>img {
    width: 100%;
}
ul>li, ol>li {
    margin-right: 30px !important;
}
</style>